import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';
import classNames from 'classnames';
import { Button as ButtonControl, CircularProgress } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';
import { Blocker } from '../Blocker';

const useStyles = makeStyles<Theme>(() => ({
  root: {
    display: 'inline-flex',
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

interface Props extends ButtonProps {
  loading?: boolean;
}

export const Button = ({ loading, className, disabled, ...props }: Props) => {
  const classes = useStyles();

  return (
    <div className={classNames(className, classes.root)}>
      <ButtonControl {...props} disabled={disabled || loading} />
      {loading && <CircularProgress className={classes.progress} size={24} />}
      {loading && <Blocker />}
    </div>
  );
};
